module.exports = __webpack_public_path__ + "img/logo-7204.311ff888.png";